<template>
  <div>
    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <button
          type="button"
          :class="['btn ai-builder-btn-info', { active: show_info }]"
          :title="$t('reusable.aiThemeInput.infoToggle')"
          :aria-label="$t('reusable.aiThemeInput.infoToggle')"
          @click="show_info = !show_info"
        >
          <span aria-hidden="true">&#9432;</span>
        </button>
      </div>
      <input
        :value="value"
        type="text"
        class="form-control ai-builder-theme-input"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :title="hint"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)"
      />
      <div class="input-group-append">
        <slot name="append"></slot>
      </div>
    </div>
    <p v-if="show_info" class="ai-builder-theme-info">
      {{ info }}
    </p>
    <p v-if="at_max" class="ai-builder-theme-warning" role="alert">
      &#9888;
      {{ $t("reusable.aiThemeInput.maxWarning", { max: maxlength }) }}
    </p>
  </div>
</template>

<script>
// Input de "tema" compartido por los modales de creación rápida con IA:
// botón ⓘ que despliega una ayuda con ejemplos (para orientar sin tener que
// redactar extenso) y aviso cuando el texto alcanza el máximo permitido
// (mismo tope que valida el backend en parse_theme). El botón de acción
// (regenerar/agregar) lo aporta el padre vía el slot "append".
export default {
  name: "AiThemeInput",
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    // Tooltip corto (atributo title del input).
    hint: {
      type: String,
      default: "",
    },
    // Ayuda extendida con ejemplos, ya traducida por el padre.
    info: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      show_info: false,
    };
  },
  computed: {
    at_max() {
      return (this.value || "").length >= this.maxlength;
    },
  },
};
</script>

<style scoped src="./ai-builder.css"></style>
